import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";
import { searchDoctor } from "../constants/ApiConstants";
import TeamSlider from "../components/Slider/TeamSlider";
import Section from "../components/Section";
import BreadcrumbStyle2 from "../components/Breadcrumb/BreadcrumbStyle2";
import styled from "styled-components";
import { pageTitle } from "../helpers/PageTitle";
import FullPageLoader from "../components/FullPageLoader";

export default function DepartmentDetails() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filters, setFilters] = useState({
    gender: searchParams.get("gender") || "",
    sortType: searchParams.get("sortType") || "",
    category: { id: searchParams.get("categoryId") || "" },
    start: 0,
    count: 12,
  });
  const getInitialPageTitle = () => {
    if (searchParams.get("fromSearch")) {
      return `Search results for "${searchParams.get("title")}"`;
    } else {
      return `${searchParams.get("title") || "Find "} Doctors`;
    }
  };

  const [title, setTitle] = useState(getInitialPageTitle());

  pageTitle(title + " - Find Doctor");

  const [loading, setLoading] = useState(false);
  const [doctors, setDoctors] = useState([]);

  const onFilterChanged = (updatedFilters) => {
    const newFilters = { ...filters, ...updatedFilters };
    setFilters(newFilters);
    updateURLParams(newFilters);
  };

  const updateURLParams = (newFilters) => {
    const params = new URLSearchParams();
    if (newFilters.gender) params.set("gender", newFilters.gender);
    if (newFilters.sortType) params.set("sortType", newFilters.sortType);
    if (newFilters.category.id) params.set("categoryId", newFilters.category.id);
    setSearchParams(params);
  };

  useEffect(() => {
    fetchData();
  }, [filters]);

  const fetchData = async () => {
    setLoading(true);
    const body = {
      sort_type: filters.sortType,
      category_id: filters.category.id,
      start: filters.start,
      count: filters.count,
    };

    try {
      const res = await axiosInstance.post(searchDoctor, body);
      setDoctors(res.data.data || []);
    } catch (error) {
      console.error("Error fetching doctors:", error);
    }

    setLoading(false);
  };

  return (
    <Section topMd={120} topLg={40} topXl={60} bottomMd={200} bottomLg={150} bottomXl={110}>
      <BreadcrumbStyle2 />
      <DoctorsContainers>
        {/* <h3 style={{ padding: 12, marginTop: 18, maxWidth: 1024 }}>{`${title} Doctors`}</h3> */}
        <TeamSlider loading={loading} filters={filters} onFilterChanged={onFilterChanged} data={doctors} />
      </DoctorsContainers>
    </Section>
  );
}

const DoctorsContainers = styled.section`
  max-width: 1224px;
  margin: 0 auto;
  @media screen and (max-width: 991px) {
    .cs_height_lg_150 {
      height: 0 !important;
    }
  }
`;
